module.exports = __webpack_public_path__ + "static/img/ri-calendar-todo-line.6629912d.svg";